import { primitiveColors } from 'fitify-ui/src/theme/generated/primitive-colors'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import { styled } from 'styled-components'

export const StyledImage = styled.img`
  align-self: center;
  margin-top: 24px;
`

export const StyledPercentageDiscountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  margin-top: 24px;
`

export const StyledPercentageDiscountContainer = styled.div`
  position: relative;
  width: 200px;
  height: 105px;
  transform: rotate(-10deg);
`

export const StyledPercentageDiscountTextContainer = styled.div`
  position: absolute;
  top: 50%;
  bottom: 0;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 0 4px;
`

export const StyledPercentageDiscountHeading = styled.div`
  ${typographyStyles('Poppins/T1 - Semibold')};
  color: ${primitiveColors['New Primitives Web']['General/White']};
  font-size: 21px !important;
  text-align: center;
`

export const StyledPercentageDiscountSubheading = styled.div`
  ${typographyStyles('Poppins/T5')};
  color: ${primitiveColors['New Primitives Web']['General/White']};
  font-size: 10px !important;
  text-align: center;
`
